// extracted by mini-css-extract-plugin
export default {"root":"coupon-list_root__Y67ue"};